import React, { useState } from 'react';
import './EmployeeNavbar.css';

import { EMPLOYEE_DASHBOARD } from '../../../../data/StateValues';

import { Fade } from 'react-reveal';

export default function EmployeeNavbar(props) {
    const [applicationsSelected, setApplicationsSelected] = useState(false);

    const renderApplicationButton = () => {
        if (applicationsSelected) {
            return (
                <>

                    <div className='employee-dashboard-nav-application-dropdown'>
                        <button className={props.applications > 0 ? 
                        props.displaying === EMPLOYEE_DASHBOARD.applications
                        ? "pending-button-selected" : "pending-button" :  
                        props.displaying === EMPLOYEE_DASHBOARD.applications ? "approved-button-selected" : "approved-button"}
                            onClick={() => {
                                setApplicationsSelected(!applicationsSelected);
                            }}>
                            <i class={applicationsSelected ? "fa-solid fa-angle-down" : "fa-solid fa-angle-right"} /> Applications ({props.applications})</button>
                        <Fade delay={100}>
                            <button className={props.applications > 0 ? "pending-button employee-dashboard-nav-application-dropdown-child" : "approved-button employee-dashboard-nav-application-dropdown-child"}
                                onClick={() => {
                                    props.updateDisplay(EMPLOYEE_DASHBOARD.applications);
                                }}>
                                Assistance ({props.applications})</button>
                        </Fade>

                        <Fade delay={200}>
                            <button className={props.applications > 0 ? "pending-button employee-dashboard-nav-application-dropdown-child" : "approved-button employee-dashboard-nav-application-dropdown-child"}
                                onClick={() => {
                                    props.updateDisplay(EMPLOYEE_DASHBOARD.affiliateApplications);
                                }}>
                                Affiliate</button>
                        </Fade>

                        <Fade delay={300}>
                            <button className={props.applications > 0 ? "pending-button employee-dashboard-nav-application-dropdown-child" : "approved-button employee-dashboard-nav-application-dropdown-child"}
                                onClick={() => {
                                    props.updateDisplay(EMPLOYEE_DASHBOARD.employeeApplications);
                                }}>
                                Employee</button>
                        </Fade>
                    </div>
                </>
            )
        }

        return (
            <div>
                <button className={props.applications > 0 ? "pending-button" : "approved-button"}
                    onClick={() => {
                        setApplicationsSelected(!applicationsSelected);
                    }}><i class={applicationsSelected ? "fa-solid fa-angle-down" : "fa-solid fa-angle-right"} /> Applications ({props.applications})</button>
            </div>
        )
    }



    return (
        <>

            <div className='employee-navbar-items'>
                {renderApplicationButton()}

                <div>
                    <button className={props.events === 0 ? 
                        props.displaying === EMPLOYEE_DASHBOARD.events
                        ? "pending-button-selected" : "pending-button" :  
                        props.displaying === EMPLOYEE_DASHBOARD.events ? "approved-button-selected" : "approved-button"}
                        onClick={() => {
                            props.updateDisplay(EMPLOYEE_DASHBOARD.events);
                        }}>
                        Events ({props.events})</button>
                </div>

                <div>
                <button className={props.reports === 0 ? 
                        props.displaying === EMPLOYEE_DASHBOARD.reports
                        ? "denied-button-selected" : "denied-button" :  
                        props.displaying === EMPLOYEE_DASHBOARD.reports ? "approved-button-selected" : "approved-button"}
                        onClick={() => {
                            props.updateDisplay(EMPLOYEE_DASHBOARD.reports);
                        }}>
                        Reports ({props.reports})</button>
                </div>

                <div>
                    <button className={props.displaying === EMPLOYEE_DASHBOARD.stats ? 'all-button-selected' : 'all-button'}
                        onClick={() => {
                            props.updateDisplay(EMPLOYEE_DASHBOARD.stats);
                        }}>
                        Statistics</button>
                </div>

                <div>
                <button className={props.displaying === EMPLOYEE_DASHBOARD.settings ? 'search-button-selected' : 'search-button'}
                        onClick={() => {
                            props.updateDisplay(EMPLOYEE_DASHBOARD.settings);
                        }}>
                        Settings</button>
                </div>

            </div>
        </>
    )
}